import { builderDispatch, WebUI } from '../../_utils/ui';
import { GoogleAnalyticsBeginCheckoutEvent } from './events/begin-checkout';
import { GoogleAnalytics } from './google-analytics';


const AnalyticsHandler = {
  handleAnalyticsEvent(payload) {
    switch (payload.type) {
      case WebUI.Analytics.SEND:
        this.handleSendEvent(payload);
        break;

      case WebUI.Analytics.BEGIN_CHECKOUT_EVENT:
        this.handleBeginCheckoutEvent();
        break;
    }
  },

  handleSendEvent({ eventCategory, eventAction, eventLabel, eventValue }) {
    new GoogleAnalytics().sendEvent(eventAction, {
      eventCategory,
      eventAction,
      eventLabel,
      eventValue: eventValue || 0,
    });
  },

  handleBeginCheckoutEvent() {
    new GoogleAnalyticsBeginCheckoutEvent().sendEvent();
  }
};

export default AnalyticsHandler;
